import {
  httpApps,
  httpAdminCompanyLocation,
  httpDealer,
} from "../helper/http-common";

class SelectYourDiamoiondServices {
  GetStudBuilderOpeningPage(inputData) {
    return httpApps.post(
      "studBuilderForML/GetStudBuilderOpeningPage",
      inputData
    );
  }
  GetRingBuilderSelectLabDiamond(inputData) {
    return httpApps.post(
      "RingBuilderForML/GetRingBuilderSelectLabDiamond",
      inputData
    );
  }

  GetRingBuilderSelectMinedDiamond(inputData) {
    return httpApps.post(
      "RingBuilderForML/GetRingBuilderSelectMinedDiamond",
      inputData
    );
  }

  GetAvailableStudBuilderFilters(inputData) {
    return httpApps.post(
      "studBuilderForML/GetAvailableStudBuilderFilters",
      inputData
    );
  }

  SendMailToRetailerForNoResults(inputData) {
    return httpApps.post(
      "RingBuilderForML/SendMailToRetailerForNoResults",
      inputData
    );
  }
  GetRingBuilderMinedCompareData(inputData) {
    return httpApps.post(
      "RingBuilderForML/GetRingBuilderMinedCompareData",
      inputData
    );
  }

  GetRingBuilderLabCompareData(inputData) {
    return httpApps.post(
      "RingBuilderForML/GetRingBuilderLabCompareData",
      inputData
    );
  }

  RingBuilderRequestCertificate(inputData) {
    return httpApps.post(
      "RingBuilderForML/RingBuilderRequestCertificate",
      inputData
    );
  }

  GetDealerInformation(inputData) {
    return httpApps.post("DiamondLinkForML/GetDealerInformation", inputData);
  }
  LoadDiamonds(inputData) {
    return httpApps.post("studBuilderForML/LoadDiamonds", inputData);
  }
  GetstudBuilderOptiondetails(inputData) {
    return httpApps.post(
      "studBuilderForML/GetstudBuilderOptiondetails",
      inputData
    );
  }
  GetAvailableStudbuilderFilters(inputData) {
    return httpApps.post(
      "studBuilderForML/GetAvailableStudbuilderFilters",
      inputData
    );
  }
  GetSimilarDiamondsByPage(inputData, pageName) {
    if (pageName == "Mined") {
      return httpApps.post(
        "RingBuilderForML/GetRingBuilderSelectMinedDiamond",
        inputData
      );
    } else {
      return httpApps.post(
        "RingBuilderForML/GetRingBuilderSelectLabDiamond",
        inputData
      );
    }
  }
  ProductTracking(inputData) {
    return httpApps.post("DiamondLinkForML/ProductTracking", inputData);
  }
  DiamondTracking(inputData) {
    return httpApps.post("DiamondLinkForML/DiamondTracking", inputData);
  }
  GetMenuList(inputData) {
    return httpAdminCompanyLocation.post("/Tools/GetMenuListForML", inputData);
  }
  CompanyWhileLabel() {
    return httpDealer.get("/Dashboard/CompanyWhileLabelForML");
  }
  GetLanguage(inputData) {
    return httpAdminCompanyLocation.post(
      "/SelectLenguage/SelectlanguageForDelarForML",
      inputData
    );
  }
}

export default new SelectYourDiamoiondServices();
